
import { BoolField } from "./BoolField";
import { DateField } from "./DateField";
import { GenericTooltip } from "./GenericTooltip";
import { NumberField } from "./NumberField";
import { SelectField } from "./SelectField";
import { TextField } from "./TextField";
import { DateTimeField } from "./DateTimeField";
import { useState } from "react";

export const  GenericFormFields = ({fieldInfo, onFieldChange, initialData, detail, index, showFieldName, mandatoryOnly, ...props}) => {
    const [detailIndex] = useState(index);
    
//console.log(fieldInfo);
    /**
     * @param {*} objData {fieldConfig, detail, index, e}
     */
    const handleFieldChange = (value, fieldName, objData) =>{
        if(onFieldChange)
            onFieldChange(fieldName, value, objData)
    }
    return (
      <>
            {Object.entries(fieldInfo).map(
                ([fieldName, fieldConfig], index) =>{
                    const { Type, Trans, ValidValues } = fieldConfig;
                    const doesTypeExist = ["string", "number", "date", "bool", "datetime"].indexOf(Type?.toLowerCase()) > -1 ? true : false;

                    return (
                    <div key={`${fieldName}-row${index}`} {...props}>
                        <div style={{whiteSpace:"nowrap"}}>
                          <label>{showFieldName ?  fieldName : (Trans?.Title  || fieldName)}</label>  
                          <GenericTooltip tooltip={Trans?.Tooltip} fieldName={fieldName} ></GenericTooltip>
                        </div>
                        {Type?.toLowerCase() === "string" && !ValidValues &&
                          <TextField fieldConfig={fieldConfig} fieldName={fieldName} onChange={handleFieldChange} detail={detail} index={detailIndex} disabled={!fieldConfig?.Mandatory&&mandatoryOnly}></TextField>
                        }
                        {Type?.toLowerCase() === "number" &&
                          <NumberField fieldConfig={fieldConfig} fieldName={fieldName} onChange={handleFieldChange} detail={detail} index={detailIndex} disabled={!fieldConfig?.Mandatory&&mandatoryOnly}></NumberField>
                        }
                        {Type?.toLowerCase() === "bool" &&
                          <BoolField fieldConfig={fieldConfig} fieldName={fieldName} onChange={handleFieldChange} detail={detail} index={detailIndex} disabled={!fieldConfig?.Mandatory&&mandatoryOnly}></BoolField>
                        }
                        {ValidValues && ValidValues.length > 0 &&
                          <SelectField fieldConfig={fieldConfig} fieldName={fieldName} onChange={handleFieldChange} detail={detail} index={detailIndex} disabled={!fieldConfig?.Mandatory&&mandatoryOnly}></SelectField>
                        }
                        {Type?.toLowerCase() === "date" &&
                          <DateField fieldConfig={fieldConfig} fieldName={fieldName} onChange={handleFieldChange} detail={detail} index={detailIndex} disabled={!fieldConfig?.Mandatory&&mandatoryOnly}></DateField>
                        }
                        {Type?.toLowerCase() === "datetime" &&
                          <DateTimeField fieldConfig={fieldConfig} fieldName={fieldName} onChange={handleFieldChange} detail={detail} index={detailIndex} disabled={!fieldConfig?.Mandatory&&mandatoryOnly}></DateTimeField>
                        }
                        {!doesTypeExist &&
                          <TextField fieldConfig={fieldConfig} fieldName={fieldName} onChange={handleFieldChange} detail={detail} index={detailIndex} disabled={!fieldConfig?.Mandatory&&mandatoryOnly}></TextField>
                        }
                    </div>)
                }
            )}
      </>
    )
}